import React, { Fragment } from "react";
import { useDispatch } from "react-redux";
import { FormattedMessage } from "react-intl";

import { Icon } from "../../icon/Icon";
import { openUnmergeModal } from "../devices.actions";
import { LazyLoadDropdownItem } from "@sportal/cdk/dropdown/LazyLoadDropdownItem";
import { DeviceActionsModalItem } from "../DeviceActionsDialog";

/**
 * @param {*} device { identifiers, name, profile }
 */
export const useUnmergeDeviceMenuItem = (device) => {
  const dispatch = useDispatch();

  return {
    id: "unmerge",
    content: (
      <Fragment>
        <Icon icon="fa-solid fa-unlink" />
        <span>
          <FormattedMessage id="unmerge" />
        </span>
      </Fragment>
    ),
    action: () => dispatch(openUnmergeModal(device)),
  };
};

export const UnmergeDeviceDropdownItem = ({ device, ...props }) => {
  const { id, content, action } = useUnmergeDeviceMenuItem(device);

  return (
    <LazyLoadDropdownItem id={id} action={action} {...props}>
      {content}
    </LazyLoadDropdownItem>
  );
};

export const UnmergeDeviceModalItem = ({ device }) => {
  const { id, content, action } = useUnmergeDeviceMenuItem(device);

  return (
    <DeviceActionsModalItem id={id} action={action}>
      {content}
    </DeviceActionsModalItem>
  );
};
